import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import { Box, Link, Text } from '@chakra-ui/react'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import OfferApprovalService from '../services/offerApproval.service'

const useOfferApproval = () => {
  const service = new OfferApprovalService()
  const queryClient = useQueryClient()

  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useContributorReview = useAction({
    mutationFn: service.contributorReview,
    queryKey: queryKey,
    message: 'Successfully review as contributor',
  })
  const useContributorComment = useAction({
    mutationFn: service.contributorComment,
    queryKey: queryKey,
    message: 'Successfully comment as contributor',
  })
  const useApproveOfferQuotation = useAction({
    mutationFn: service.approveOfferQuotation,
    queryKey: queryKey,
    message: 'Successfully approve quotation',
  })
  const useRejectOfferQuotation = useAction({
    mutationFn: service.rejectOfferQuotation,
    queryKey: queryKey,
    message: 'Successfully reject quotation',
  })
  const useApproveOfferBooking = useAction({
    mutationFn: service.approveOfferBooking,
    queryKey: queryKey,
    message: 'Successfully approve booking',
  })
  const useRejectOfferBooking = useAction({
    mutationFn: service.rejectOfferBooking,
    queryKey: queryKey,
    message: 'Successfully reject booking',
  })

  const submitErrorHandling = (error) => {
    //TODO: Add back error handle for switch tab
    const errorResponseObj = error?.response?.data
    console.log(errorResponseObj)

    if (errorResponseObj?.type === 'MISSING_SIGNATURE_LABEL') {
      toast.error(
        <Box>
          <Text>{errorResponseObj.message}</Text>
          <Link
            color={'teal'}
            // eslint-disable-next-line max-len
            href="https://siemens.sharepoint.com/:x:/r/teams/P0008560/Share%20Documents/Forms%20and%20Templates/LoA/Quotation_Template-202410%20(PM040%20PM070)%20V1.1.xlsm?d=w6d81b76fcf494786806e24cdcff5b95e&csf=1&web=1&e=ukq7WH&xsdata=MDV8MDJ8YW50cmlwLmhvQHNpZW1lbnMuY29tfGNjOGQ0ODE3NTI5ODRiZWFhMTUxMDhkY2UzOWNjNDlhfDM4YWUzYmNkOTU3OTRmZDRhZGRhYjQyZTE0OTVkNTVhfDF8MHw2Mzg2MzU1MDk2OTk2NzIwNTl8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpXSWpvaU1DNHdMakF3TURBaUxDSlFJam9pVjJsdU16SWlMQ0pCVGlJNklrMWhhV3dpTENKWFZDSTZNbjA9fDB8fHw%3d&sdata=WDU0bUsrdW5XVWwzNWYyMkpCQUc3RU54ZmN1QklSNGh2ZUpUZmQyVzZWND0%3d"
            isExternal
          >
            Link to Cost Sheet Template
          </Link>
        </Box>
      )
    } else if (errorResponseObj?.type === 'MISSING_SIGNATURE') {
      toast.error(errorResponseObj.message)
    }

    //FIXME: reload screen if error is from Damex-E
    // if (errorResponseObj.message.includes('Damex-E') || errorResponseObj.message.includes('contributors')) {
    //   queryClient.invalidateQueries(queryKey.detail(offerId))
    // }
  }

  const useResumeOfferQuotation = useAction({
    mutationFn: service.resumeOfferQuotation,
    queryKey: queryKey,
    message: 'Successfully Resume Quotation',

    onError: submitErrorHandling,
  })
  const useRestartOfferQuotation = useAction({
    mutationFn: service.restartOfferQuotation,
    queryKey: queryKey,
    message: 'Successfully Restart Quotation',
    onError: submitErrorHandling,
  })
  const useResumeOfferBooking = useAction({
    mutationFn: service.resumeOfferBooking,
    queryKey: queryKey,
    message: 'Successfully Resume Booking',

    onError: submitErrorHandling,
  })
  const useRestartOfferBooking = useAction({
    mutationFn: service.restartOfferBooking,
    queryKey: queryKey,
    message: 'Successfully Restart Booking',

    onError: submitErrorHandling,
  })

  const useBatchApprove = useAction({
    mutationFn: service.batchApprove,
    queryKey: queryKey,
    message: 'Successfully Batch Approve',
    shouldRefresh: false,
  })
  const useSubmitOfferQuotation = useAction({
    mutationFn: service.submitOfferQuotation,
    queryKey: queryKey,
    message: 'Successfully Submit Offer Quotation',
    onError: submitErrorHandling,
  })
  const useSubmitOfferBooking = useAction({
    mutationFn: service.submitOfferBooking,
    queryKey: queryKey,
    message: 'Successfully Submit Offer Booking',
    onError: submitErrorHandling,
  })

  return {
    //Contribution
    useContributorReview,
    useContributorComment,

    //Quotation Approval
    useApproveOfferQuotation,
    useRejectOfferQuotation,

    //Booking Approval
    useApproveOfferBooking,
    useRejectOfferBooking,

    //Misc
    useSubmitOfferQuotation,
    useSubmitOfferBooking,
    useResumeOfferQuotation,
    useRestartOfferQuotation,
    useResumeOfferBooking,
    useRestartOfferBooking,

    useBatchApprove,
  }
}

export default useOfferApproval
